'use client'

import Icon from "@/components/etc/icon";
import { BetContext } from "@/context/BetContext";
import { betFolderTypes, folderSelectionType, marketType, membersType, selectionType, ticketResult } from "@/type/sports";
import moment from "moment";
import React, { ReactNode, useContext, useEffect, useState } from "react";

const BaseDetailContainer = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
    ({ children, ...rest }, ref) => {

        return (
            <li>{children}</li>
        );
    }
);

BaseDetailContainer.displayName = "Detail";

interface detailInfoTypes {
    league_name: string
    match_datetime: string
    home: string
    away: string
}
const Info: React.FC<detailInfoTypes & React.HTMLAttributes<HTMLDivElement>> = ({
    league_name,
    match_datetime,
    home,
    away,
    ...rest }) => (<>
        <div className="match-info">
            <span>{league_name}</span>
            <span>{moment(match_datetime).format('MM-DD HH:mm')}</span>
        </div>
        <div className="versus">
            <span>{home}</span>
            <span>Vs</span>
            <span>{away}</span>
        </div>
    </>);

const MarketContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = ({
    children, ...rest }) => (<div className="markets" >{children}</div>)

interface selectionTypes {
    folder: betFolderTypes
}
const Selections: React.FC<selectionTypes & React.HTMLAttributes<HTMLDivElement>> = ({
    folder,
    ...rest
}) => {
    let isDraw = false
    const selections = folder.selections
    const returnJsx: ReactNode[] = []
    const SelectNode: React.FC<{ sl: folderSelectionType }> = ({ sl }) => {
        return (
            <div className={`box ${sl.kind} ${sl.is_selected ? "selected" : ""} ${sl.selection_id == folder.actual_selection_id ? "won" : ""}`}>
                <span>{sl.name}</span>
                <span>{Number(sl.odds).toFixed(2)}</span>
            </div>
        )
    }
    const UnSelectNode: React.FC<{ name?: any, resultBtn?: boolean, result?: string }> = ({ name, resultBtn, result }) => {
        return (
            <div className={`box ${resultBtn ? `result ${result || ''}` : ""}`}>
                <span>{name}</span>
            </div>
        )
    }

    // 승패 / 승무패
    if ([5498, 377, 4475, 399, 6544, 6564].includes(folder.market_type_id)) {
        isDraw = true
        const w1 = selections.find((el) => el.kind == 'W1')
        const x = selections.find((el) => el.kind == 'X')
        const w2 = selections.find((el) => el.kind == 'W2')

        if (w1) {
            returnJsx.push(<SelectNode sl={w1} />)
        } else {
            returnJsx.push(<UnSelectNode />)
        }
        // 
        if (x) {
            returnJsx.push(<SelectNode sl={x} />)
        } else {
            returnJsx.push(<UnSelectNode name={'vs'} />)
        }
        // 
        if (w2) {
            returnJsx.push(<SelectNode sl={w2} />)
        } else {
            returnJsx.push(<UnSelectNode />)
        }
    }
    else if ([5500, 374, 4478, 8694, 6546, 6575].includes(folder.market_type_id)) {
        // 오버 / 언더
        const over = selections.find((el) => el.kind == 'Over')
        const under = selections.find((el) => el.kind == 'Under')

        if (under) {
            returnJsx.push(<SelectNode sl={under} />)
        } else {
            returnJsx.push(<UnSelectNode />)
        }
        // 기준점
        returnJsx.push(<UnSelectNode name={'0'} />)
        // 
        if (over) {
            returnJsx.push(<SelectNode sl={over} />)
        } else {
            returnJsx.push(<UnSelectNode />)
        }
    }
    else if ([5503, 378, 4477, 8692, 6549, 6565].includes(folder.market_type_id)) {
        // 핸디캡
        const home = selections.find((el) => el.kind == 'Home')
        const away = selections.find((el) => el.kind == 'Away')

        if (home) {
            returnJsx.push(<SelectNode sl={home} />)
            // 기준점
            returnJsx.push(<UnSelectNode name={home.name} />)
        } else {
            returnJsx.push(<UnSelectNode />)
            returnJsx.push(<UnSelectNode />)
        }
        // 
        if (away) {
            returnJsx.push(<SelectNode sl={away} />)
        } else {
            returnJsx.push(<UnSelectNode />)
        }
    }
    returnJsx.push(<UnSelectNode name={ticketResult[folder.status]}
        resultBtn
        //  result={folder.actual_selection_id == folder.selection_id ? "won" : ""} />)
        result={folder.status} />)

    return (
        <div className={`selections ${isDraw ? "draw" : ""}`}>
            {
                returnJsx.map((jsx, index)=> (
                    <div key={index}>{jsx}</div>
                ))
            }
        </div>
    );
}



type BetBaseComponent = React.ForwardRefExoticComponent<
    React.HTMLAttributes<HTMLDivElement> & React.RefAttributes<HTMLDivElement>
> & {
    Info: typeof Info;
    MarketContainer: typeof MarketContainer;
    Selections: typeof Selections;
};

const DetailContainer = BaseDetailContainer as BetBaseComponent;
DetailContainer.Info = Info;
DetailContainer.MarketContainer = MarketContainer;
DetailContainer.Selections = Selections;


export default DetailContainer;